export {
  PUBLIC_ARWEAVE_GATEWAY_HOST as ARWEAVE_PUBLIC_GATEWAY_HOST,
  PUBLIC_ARWEAVE_GATEWAY_HOSTS as ARWEAVE_PUBLIC_GATEWAY_HOSTS,
} from '../shared/arweave/publicArweaveGateway';

const API_PORT = import.meta.env.VITE_API_PORT ?? 3333;
export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL ?? `http://localhost:${API_PORT}`;
export const TRPC_URL = import.meta.env.VITE_TRPC_URL ?? '/api/trpc';

const parseNumber = (value: unknown, fallback: number): number => {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};

const parseBoolean = (value: unknown, fallback = false): boolean => {
  if (typeof value !== 'string') {
    return fallback;
  }

  const normalized = value.trim().toLowerCase();
  if (normalized === 'true') {
    return true;
  }
  if (normalized === 'false') {
    return false;
  }
  return fallback;
};

const parseCsv = (value: unknown): string[] => {
  if (typeof value !== 'string') {
    return [];
  }

  return value
    .split(',')
    .map((item) => item.trim())
    .filter((item) => item.length > 0);
};

const extractHostname = (value: string): string | null => {
  try {
    return new URL(value).hostname.toLowerCase();
  } catch {
    try {
      return new URL(`https://${value}`).hostname.toLowerCase();
    } catch {
      return null;
    }
  }
};

const R2_PUBLIC_BASE_URLS = [
  'https://r2.solanaappstore.com',
  'https://r2-staging.solanamobiledappstore.com',
  'https://r2.solanamobiledappstore.com',
] as const;
const DEFAULT_R2_PUBLIC_BASE_URL =
  R2_PUBLIC_BASE_URLS[
    import.meta.env.VITE_ENVIRONMENT === 'production' ? 0 : 1
  ];

export const R2_UPLOADS_ENABLED = parseBoolean(
  import.meta.env.VITE_ENABLE_R2_UPLOADS,
  true,
);
const R2_PUBLIC_BASE_URL =
  import.meta.env.VITE_R2_PUBLIC_BASE_URL?.trim() || DEFAULT_R2_PUBLIC_BASE_URL;
export const R2_PUBLIC_HOSTS = Array.from(
  new Set(
    [
      ...parseCsv(import.meta.env.VITE_R2_PUBLIC_HOSTS),
      ...R2_PUBLIC_BASE_URLS,
      R2_PUBLIC_BASE_URL,
    ]
      .map((value) => extractHostname(value))
      .filter((value): value is string => Boolean(value)),
  ),
);

const DEFAULT_QUEST_COMPLETION_API_URL =
  import.meta.env.VITE_ENVIRONMENT === 'production'
    ? 'https://publish.solanamobile.com/api/challenges/quest-completions'
    : 'https://staging.publish.solanamobile.com/api/challenges/quest-completions';

export const QUEST_COMPLETION_API_URL =
  import.meta.env.VITE_QUEST_COMPLETION_API_URL?.trim() ||
  DEFAULT_QUEST_COMPLETION_API_URL;

export const ARDRIVE_BACKEND_UPLOAD_MAX_BYTES = parseNumber(
  import.meta.env.VITE_ARDRIVE_BACKEND_MAX_BYTES,
  3 * 1024 * 1024 * 1024,
);
export const ARDRIVE_BACKEND_UPLOAD_TIMEOUT_MS = parseNumber(
  import.meta.env.VITE_ARDRIVE_BACKEND_UPLOAD_TIMEOUT_MS,
  30 * 60 * 1000,
);

export const ARDRIVE_STAGED_UPLOAD_POLL_INTERVAL_MS = parseNumber(
  import.meta.env.VITE_ARDRIVE_STAGED_UPLOAD_POLL_INTERVAL_MS,
  5000,
);

export const ARDRIVE_STAGED_UPLOAD_TIMEOUT_MS = parseNumber(
  import.meta.env.VITE_ARDRIVE_STAGED_UPLOAD_TIMEOUT_MS,
  45 * 60 * 1000,
);
